<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       v-model="selectedItemIds"
                       data-url="admin/abbreviation/"
                       data-key="abbreviations"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs"
                       class="abbreviation-list">
    <template v-slot:item.actions="{item}">
      <v-btn text
             color="primary"
             @click="deleteItem(item)">
        Delete
      </v-btn>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'AbbreviationList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh(true);
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = ref([
      {text: root.$t('abbreviation.phrase'), value: 'phrase', contains: true},
      {text: root.$t('abbreviation.abbreviation'), value: 'abbreviation', contains: true},
    ])

    // Data Table
    const headers = ref([
      {text: root.$t('abbreviation.phrase'), value: 'phrase'},
      {text: root.$t('abbreviation.abbreviation'), value: 'abbreviation'},
      {text: '', value: 'actions', sortable: false, width: '50px'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });
    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = async function (item) {
      root.$router.push({name: 'user-detail', params: {userId: item.id}});
    }

    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({text: 'Delete Abbreviation?'})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/abbreviation/delete/',
          params: {phrase: item.phrase},
        })

        if (response.body.success) {
          await refresh();
        }
      }
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteItem,
    }
  }
}
</script>
